import React, { useEffect, useState } from "react";
import Utility, { deepClone } from "../../../../../utility/Utility";
import {DKInput, DKButton, DKSpinner, DKLabel, DKLine, DKCalendar} from "deskera-ui-library"
import { FORMAT, INPUT_TYPE } from "../../../../../constants/Constant";
import RouteManager from "../../../../../managers/RouteManager";
import EmployeeListService from "../../../../../services/EmployeeListService";
import moment from 'moment'
import { useDispatch, useSelector } from "react-redux";
import { fetchCPFAccount, selectCPFAccounts } from "../../../../../Redux/Slices/EmployeeListSlice";
import { getIRASReportYears } from "../../../../../managers/common/CommonUtil";

const AISSubmissionFieldSection = (props) => {
    
    /**Hooks */
    const [formConfig, setFormConfig] = useState(deepClone(props.formConfig));
    const [firstSection, setFirstSection] = useState(props.formConfig?.FIRST_SECTION || []);
    const [formValues, setFormValues] = useState(props?.formValues || {});
    const [formYears, setFormYears] = useState(getIRASReportYears());

    /**Selectors */
    const cpfAccountDetails = useSelector(selectCPFAccounts);

    /**Dispatcher */
    const dispatch = useDispatch();  

    useEffect(() => {
        prepareExternalOptionsData();
    },[cpfAccountDetails]);

    const prepareExternalOptionsData = () => {
        const sectionOne = deepClone(firstSection);
        const alteredConfig = [];
        sectionOne.forEach(field => {
            switch(field.columnCode) {
                case "cpfAccount":
                    let cpfOptions = [];
                    if(cpfAccountDetails?.accounts?.length > 0) {
                        let accounts = cpfAccountDetails.accounts.map((account) => {
                            return {
                              id: account.accountId,
                              name: account?.compliance?.name,
                              accountType: account.accountType,
                              compliance: account.compliance,
                            };
                        });
                        cpfOptions =  accounts;
                    }
                    alteredConfig.push({columnCode:"cpfAccount", options: cpfOptions});
                    break; 
                case "year":
                    const currentYear = new Date().getFullYear();
                    const yearValue = EmployeeListService.getValueObjectFromDropdown(currentYear, formYears, "id");
                    if (!Utility.isEmptyObject(yearValue)) formValues["year"] = yearValue;
                    alteredConfig.push({columnCode:"year", options: formYears});
                    break;
                case "datePeriod":
                    alteredConfig.push({columnCode:"datePeriod", toggle: false, defaultDate: false, hasError: false, errorMsg:'End date should not be less than Start date'});
                    if(Utility.isEmpty(formValues["datePeriod"])) {
                        formValues["datePeriod"] = {startDate:moment(moment().format()).startOf('month'), endDate: moment(moment().format()).endOf('month')};
                    } 
                    break
            } 
        });
        EmployeeListService.getAlteredConfigDetails(
            sectionOne,
            alteredConfig,
            false,
            {},
            {}
        );
        setFirstSection(sectionOne);
    }

    const onValueChange = (value, object) => {
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        if(Utility.isEmpty(value)) {
            alteredConfig.push({columnCode: object.columnCode, hasError: true});
        } else {
            alteredConfig.push({columnCode: object.columnCode, hasError: false});
        }
        formValues[object.columnCode] = value;
        EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
        setFirstSection(sectionOne);
        updatePropsValue({formValues : formValues});
    }

    const onCalendarClose = (obj) => {
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        switch(obj.columnCode) {
            case "datePeriod":
                if(moment(formValues[obj.columnCode].startDate).diff(formValues[obj.columnCode].endDate) <= 0 || formValues[obj.columnCode].endDate == null) {
                    formValues[obj.columnCode] = {startDate : formValues[obj.columnCode].startDate, endDate: formValues[obj.columnCode].endDate};
                    alteredConfig.push({columnCode:"datePeriod", defaultDate: false, toggle: false, hasError: false})
                } else {
                    formValues[obj.columnCode] = {startDate : formValues[obj.columnCode].startDate, endDate: formValues[obj.columnCode].endDate};
                    alteredConfig.push({columnCode:"datePeriod", defaultDate: false, toggle: false, hasError: true, errorMsg: "End date should not be less than Start date"})
                }
        }
        EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
        setFirstSection(sectionOne);
    }

    const onDateSelect = (start, end, obj) => {
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        switch(obj.columnCode) {
            case "datePeriod" :
                if(start && end) {
                    let startDate = start //timePeriod.defaultDate ? start : timePeriod.startDate;
                    let endDate = end//timePeriod.defaultDate ? timePeriod.endDate : end;
                    let mStartDate = moment(start);
                    let mEndDate = moment(end);
                    if(moment(startDate).diff(endDate) <= 0 || endDate == null) {
                        formValues[obj.columnCode] = {startDate : mStartDate, endDate: mEndDate}
                        alteredConfig.push({columnCode:"datePeriod", defaultDate: false, toggle: false, hasError: false, errorMsg: "End date should not be less than Start date"})
                    } else {
                        formValues[obj.columnCode] = {startDate : mStartDate, endDate: mEndDate}
                        alteredConfig.push({columnCode:"datePeriod", defaultDate: false, toggle: false, hasError: true, errorMsg: "End date should not be less than Start date"})
                    }
                    EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
                    setFirstSection(sectionOne);
                    updatePropsValue({formValues : formValues});
                }
        }
    }

    const getButtonAction= (obj) => {
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        switch(obj.columnCode) {
            case "datePeriod" :
                alteredConfig.push({columnCode:"datePeriod", defaultDate: true, toggle: !obj.toggle})
                EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
            setFirstSection(sectionOne);
            break;
            case "fetchIRASSubmission":
                if(!isValidSubmission()) {
                    return;
                }
                const params = {
                    cpfAccountId: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
                    year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id"),
                    page:0,
                    limit:20,
                    field: "employeeId",
                    order: "asc",
                    bypass: EmployeeListService.getSelectedIdFromObject(formValues["bypass"], "id")
                }
                if(props.fetchIRASSubmission) props.fetchIRASSubmission(params);
            break;
            case "fetchIRASSubmittedFile":
                if(!isValidSubmission()) {
                    return;
                }
                const submittedParams = {
                    cpfAccountId: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
                    page:0,
                    limit:20,
                    field: "employeeId",
                    order: "asc",
                    year: EmployeeListService.getSelectedIdFromObject(formValues["year"], "id")
                }   
                if(props.fetchIRASSubmittedData) props.fetchIRASSubmittedData(submittedParams);
                break;
            case "generateSubmissionLog":
                if(!isValidSubmission()) {
                    return;
                }
                const startDate = !Utility.isEmptyObject(formValues["datePeriod"]?.startDate) ? (formValues["datePeriod"].startDate).format(FORMAT.YYYYMMDD) : "";
                const endDate = !Utility.isEmptyObject(formValues["datePeriod"]?.endDate) ? (formValues["datePeriod"].endDate).format(FORMAT.YYYYMMDD) : "";
                const submissionLogsParams = {
                    startDate: startDate,
                    endDate: endDate,
                    cpfAccountId: EmployeeListService.getSelectedIdFromObject(formValues["cpfAccount"], "id"),
                    page:0,
                    limit:20,
                    sort: "fileName",
                    sortDir: "asc"
                }
                if(props.fetchSubmissionLogs) props.fetchSubmissionLogs(submissionLogsParams);
                break;

        }
    }

    const isValidSubmission = () => {
        // let validationFields = US_FORM_FIELDS[report];
        let sectionOne = deepClone(firstSection);
        const alteredConfig= [];
        for(let field = 0; field < sectionOne?.length; field++) {
            let fieldConfig = sectionOne[field];
            if(fieldConfig.type != INPUT_TYPE.BUTTON && Utility.isEmpty(formValues[fieldConfig["columnCode"]]) || (typeof(formValues[fieldConfig["columnCode"]]) === "object" && Utility.isEmptyObject(formValues[fieldConfig["columnCode"]]))) {
                let config = {columnCode: fieldConfig["columnCode"], hasError: true};
                alteredConfig.push(config);
            }
        }
        if(!Utility.isEmpty(alteredConfig.length)) {
            EmployeeListService.getAlteredConfigDetails(sectionOne, alteredConfig, false, {}, {});
            setFirstSection(sectionOne);
            return false;
        }
        return true;

    }

    const updatePropsValue = (value) => {
        if(props.updatePropsValue) {
            props.updatePropsValue(value)
        }
    }

    const getSections = (sectionData) => {
        return sectionData.map((obj, index) => {
            return(
                <>
                    {(obj.type === INPUT_TYPE.TEXT || obj.type === INPUT_TYPE.NUMBER || obj.type === INPUT_TYPE.DROPDOWN) && (
                        <div className={`${obj.className}`} style={{ width: `${obj.width}` }}>
                        <DKInput
                            title={obj.name}
                            value={formValues[obj.columnCode] ? formValues[obj.columnCode] : ""}
                            formatter={(obj) => {
                                /** How to render a selected option in case of object **/
                                return obj.name;
                            }}
                            displayKey={obj.displayKey}
                            type={obj.type}
                            required={obj.required}
                            readOnly={obj.readOnly}
                            direction={obj.direction}
                            options={obj.options}
                            onChange={(value) => {
                                onValueChange(value,obj);
                            }}
                            dropdownConfig={{
                                className: "",
                                style: {},
                                allowSearch: obj.options?.length > 6,
                                searchableKey: obj.searchableKey,
                                data: obj.options,
                                renderer: (index, obj) => {
                                    /** How to render value in Dropdown in case of object **/
                                    return <DKLabel className="" text={obj.name} />;
                                },
                                onSelect: (index, value) => { },
                            }}
                            canValidate={obj.hasError}
                            validator={(value) => {
                                return !obj.hasError;
                            }}
                            errorMessage={obj.errMsg}
                            tooltip={{
                                content: obj.tooltipText,
                                className: "warning-tooltip-prop",
                            }}
                        />
                    </div>
                    )}
                    {obj.type === INPUT_TYPE.BUTTON && obj.isButton && (
                        <>
                            <div className={`${obj.buttonConfig.buttonClass}`} style={{ marginTop: `${obj.buttonConfig.buttonStyle.marginTop}` }}>
                                <DKButton
                                    title={obj.buttonConfig.title}
                                    icon={obj.buttonConfig.icon}
                                    className={`${obj.buttonConfig.className}`}
                                    onClick={() => {
                                        getButtonAction(obj);
                                    }}
                                />
                            </div>
                            {obj.isLoading && <DKSpinner className="pl-s" />}
                        </>
                    )}
                    {obj.type === "Calendar" && (
                        <>
                        <div className={`${obj.buttonConfig.buttonClass}`} style={{ marginTop: `${obj.buttonConfig.buttonStyle.marginTop}`, width: `${obj.width}` }}>
                                <DKButton
                                    title={(!Utility.isEmpty(formValues[obj.columnCode]?.startDate) && !Utility.isEmpty(formValues[obj.columnCode]?.endDate)) ? `${Utility.formatDate(moment(formValues[obj.columnCode]?.startDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment(formValues[obj.columnCode]?.endDate).format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`: `${Utility.formatDate(moment().startOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)} - ${Utility.formatDate(moment().endOf('month').format(FORMAT.DDMMYYYY), FORMAT.DDMMYYYY)}`}
                                    icon={obj.buttonConfig.icon}
                                    className={`${obj.buttonConfig.className}`}
                                    onClick={() => {
                                        getButtonAction(obj);
                                    }}
                                />
                        </div>
                        {obj.hasError && <DKLabel className="text-red" text={obj.errorMsg}/>}
                        <div className="z-index-1" style={{marginTop:"50px", position:"absolute"}}>
                            {obj.toggle && (
                                <DKCalendar
                                className="border-m shadow-m bg-white z-index-1 mt-s"
                                isDateRange={true}
                                startDate={formValues[obj.columnCode].startDate?new Date(formValues[obj.columnCode].startDate):new Date()}
                                endDate={formValues[obj.columnCode].endDate? new Date(formValues[obj.columnCode].endDate): new Date()}
                                onClose={()=>{ onCalendarClose(obj)}}
                                onSelectDate={(start, end) => {onDateSelect(start, end,obj)}}
                                />
                            )}
                        </div>
                        </>
                    )}
                </>
            )
        })
    }
    

    const getHeaderSection = () => {
        return(
            <>
                <div className="bg-white pb-l card-shadow">
                    {!Utility.isEmptyObject(formConfig) && !Utility.isEmpty(formConfig.FORM_DESCRIPTION) && (
                        <DKLabel text={formConfig.FORM_DESCRIPTION} className="fw-m fs-l p-l" />
                    )}
                    <DKLine className="bg-gray3" />
                    <div className="d-flex p-h-l p-v-l">
                        {getSections(firstSection)}
                    </div>
                </div>
            </>
        )

    }

    return(
        <>
            {getHeaderSection()}
        </>

    )
}

export default AISSubmissionFieldSection;